import usePreviousImmediate from '@rooks/use-previous-immediate'
import { useEffect } from 'react'

import { useAccountingAppData } from 'hooks/data/accounting/accountingHook'
import useAppStore from 'store/useAppStore'

const useShowErpAccountsAvailableToast = () => {
  const { connectedToErp, isLoading, chartOfAccounts } = useAccountingAppData()

  const previousConnectedToErp = usePreviousImmediate(connectedToErp)
  const wasLoading = usePreviousImmediate(isLoading)

  const previousChartOfAccounts = usePreviousImmediate(chartOfAccounts)

  const addCosmicToast = useAppStore((store) => store.addCosmicToast)

  useEffect(() => {
    if (
      connectedToErp &&
      previousConnectedToErp &&
      !isLoading &&
      !wasLoading &&
      previousChartOfAccounts &&
      Object.keys(previousChartOfAccounts).length === 0 &&
      Object.keys(chartOfAccounts).length > 0
    ) {
      addCosmicToast({
        variant: 'primary',
        message:
          'ERP accounts ingested. Your chart of accounts have been ingested. Please navigate to the Accounting tab to begin mapping your categories.',
        timeoutMs: 10000,
      })
    }
  }, [
    addCosmicToast,
    connectedToErp,
    previousConnectedToErp,
    isLoading,
    wasLoading,
    previousChartOfAccounts,
    chartOfAccounts,
  ])
}

export default useShowErpAccountsAvailableToast
